import { Maybe } from '@passionware/monads';
import { featureFlags, forcedFeatureFlags } from '../../../features';

import { createFeatureSourceChain } from '../../../platform/feature-management/sources/chain';
import { createEnforcedFeatureFlagSource } from '../../../platform/feature-management/sources/enforced';
import { withDefaultValues } from '../../../platform/feature-management/sources/withDefault';
import { AppScopeIdentity } from 'v5/core/app-scope/appScope.types';
import { AtellioFeatureGroupDefinition } from 'v5/features';
import { FeatureFlagSource } from 'v5/platform/feature-management/feature-management';
import { myLocalStorageFeatureFlagSource } from './_private/localStorageFeatureFlagSource';
import { myServerFeatureFlagSource } from './_private/serverFeatureFlagSource.connected';
import { createFeatureService } from './FeatureService.impl';

function asScopeAwareSource(
  source: FeatureFlagSource<AtellioFeatureGroupDefinition>
): FeatureFlagSource<AtellioFeatureGroupDefinition, Maybe<AppScopeIdentity>> {
  return {
    useFeatureFlags: _scope => source.useFeatureFlags(),
    getFeatureFlags: _scope => source.getFeatureFlags()
  };
}

export const myFeatureService = createFeatureService(
  withDefaultValues(featureFlags)(
    createFeatureSourceChain<
      AtellioFeatureGroupDefinition,
      Maybe<AppScopeIdentity>
    >([
      myServerFeatureFlagSource,
      asScopeAwareSource(myLocalStorageFeatureFlagSource),
      asScopeAwareSource(createEnforcedFeatureFlagSource(forcedFeatureFlags))
    ])
  )
);
